/**
 * Relative time formatting utility ("Berapa waktu yang lalu")
 */

export function formatTimeAgo(dateInput: string | number | Date, nowTime?: number): string {
  if (!dateInput) return '-';
  const date = new Date(dateInput);
  const time = date.getTime();
  if (isNaN(time)) return '-';

  const now = nowTime || Date.now();
  const diffMs = now - time;

  // Handle future dates or clock skews under 5 seconds
  if (diffMs < 5000) {
    return 'Baru saja';
  }

  const diffSeconds = Math.floor(diffMs / 1000);
  if (diffSeconds < 60) {
    return `${diffSeconds} detik yang lalu`;
  }

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} menit yang lalu`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} jam yang lalu`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) {
    return 'Kemarin';
  }
  if (diffDays < 30) {
    return `${diffDays} hari yang lalu`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return `${diffMonths} bulan yang lalu`;
  }

  const diffYears = Math.floor(diffMonths / 12);
  return `${diffYears} tahun yang lalu`;
}

export function formatCompactTimeAgo(dateInput: string | number | Date, nowTime?: number): string {
  if (!dateInput) return '-';
  const date = new Date(dateInput);
  const time = date.getTime();
  if (isNaN(time)) return '-';

  const now = nowTime || Date.now();
  const diffMs = now - time;

  if (diffMs < 5000) return 'Baru saja';
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `${diffSec}d lalu`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m lalu`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}j lalu`;
  const diffDays = Math.floor(diffHr / 24);
  return `${diffDays}h lalu`;
}
